import React, { useState } from "react";
import { NavBarContainer } from "./NavBar.style";
import { useHistory, useLocation } from "react-router";
import { NavBarItem } from "../../components";
import Store from "../../state/store";
import Actions from "../../state/actions";
import { inject, observer } from "mobx-react";
import Burger from "../Burger/Burger";
import SVGIcon from "../../icons";
import { theme } from "../../Theme";

interface NavBarProps {
  store?: Store;
  mutator?: Actions;
}

const NavBar: React.FC<NavBarProps> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [isBugerOpen, setBurgerOpen] = useState(false);
  const { content } = props.store!;
  const onClickSection = (id: string) => {
    setBurgerOpen(false);
    const section = content.sections.find((section) => section.id === id);
    if (section) {
      history.push(`/section/${id}`);
    }
  };
  return (
    <>
      <Burger open={isBugerOpen} onClick={() => setBurgerOpen(!isBugerOpen)}>
        {content !== undefined &&
          content.sections.map((section) => (
            <NavBarItem
              id={section.id}
              key={section.id}
              itemTitle={section.title}
              onClick={onClickSection}
              icon={<SVGIcon name="quiz" fill={theme.color.lightText} />}
            />
          ))}
      </Burger>

      <NavBarContainer className="Navbar">
        {content !== undefined &&
          content.sections.map((section) => (
            <NavBarItem
              id={section.id}
              key={section.id}
              itemTitle={section.title}
              onClick={onClickSection}
              selected={location.pathname === `/section/${section.id}`}
              icon={
                <SVGIcon
                  name={section.type === "video" ? "video" : section.type === "resources" ? "glasses" : "quiz"}
                  style={{ marginRight: "1em" }}
                  fill={theme.color.lightText}
                />
              }
            />
          ))}
      </NavBarContainer>
    </>
  );
};

export default inject("store", "mutator")(observer(NavBar));
